import React from 'react';

// Fallback illustration for menu items without accent images yet.
export const LexicoinIllustration = () => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="40" cy="40" r="28" fill="#FFDD67" />
    <circle cx="40" cy="40" r="20" fill="#FFE392" />
    <text x="40" y="46" textAnchor="middle" fill="#9F4200" fontSize="18" fontWeight="bold" fontFamily="Poppins, sans-serif">L</text>
  </svg>
);
